export class IndicadoresConversoes {
    resgatados: number;
    pendentes: number;
    aReceber: number;
}
